import { ComponentConfig } from "@measured/puck"
import { commonStylesProps } from "../../../lib/commonCSSProps"
import { iconOptions } from "../../../lib/icons"
import { ButtonDiscoverProps, RenderConfig } from "./RenderConfig"

export const CaoCaoButton: ComponentConfig<ButtonDiscoverProps> = {
  label: "Button Discover",
  // @ts-expect-error
  fields: {
    type: {
      label: "Button Type",
      type: "select",
      options: [
        { value: "primary", label: "Primary" },
        { value: "secondary", label: "Secondary" },
      ],
    },
    size: {
      label: "Size",
      type: "select",
      options: [
        { value: "small", label: "Small" },
        { value: "medium", label: "Medium" },
        { value: "large", label: "Large" },
      ],
    },
    icon: {
      label: "Icon",
      type: "select",
      options: iconOptions,
    },

    text: {
      label: "Text",
      type: "text",
    },
    ...commonStylesProps,
  },
  defaultProps: {
    type: "primary",
    size: "medium",
    text: "Discover",
    className: "flex items-center gap-2",
    styles: {
      mobile: {
        display: "flex",
      },
      tablet: {
        display: "flex",
      },
      desktop: {
        display: "flex",
      },
    },
  },
  ...RenderConfig,
}
